import React, { useState, useEffect } from 'react'
import ColorButton from '../Buttons/ColorButton'
import apptheme from '../theme/default'
import { Box } from '@mui/material'
import '../Cadastros/styles.css'
import { useWindowSize } from "@uidotdev/usehooks";
import { hasPermissions } from '../Utils/groups'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import Prodepe from './prodepe'


const MenuList = () => {

    // const user = getSession()
    // const permissions = user?.permissions

    return ({
        'prodepe': {
            title: 'Incentivo Fiscal PE',
            icon: (<ReceiptLongIcon />),
            obj: (<Prodepe />),
            permission: (hasPermissions('grupo_administradores'))
        }
    })
}

const CalcWidthSize = (size) => {
    const threshold = size?.width < 768 ? 200 : 400
    const calcSize = Math.round(size?.width / threshold)
    if (!calcSize)
        return 2
    return calcSize
}

const ContabilIndex = () => {

    const [selectedTab, setSelectedTab] = useState()
    const size = useWindowSize();

    const menulist = MenuList()

    const calcSize = CalcWidthSize(size)

    const itens = Object.entries(menulist).filter(([key, value]) => value.permission)

    useEffect(() => {
        window.backtobase = () => setSelectedTab()
    }, [])

    return (
        <>
            {!selectedTab ?
                <>

                    <Box className='gridBox' sx={{ gridTemplateColumns: `repeat(${calcSize}, minMax(0, 1fr))` }}>
                        {itens.map(([key, value]) => (
                            <ColorButton
                                onClick={() => setSelectedTab(key)}
                                sx={{ height: '8rem', flex: 1, visibility: !value.obj ? 'hidden' : 'visible' }}
                                fColor={apptheme.primaryColor}
                                sColor={apptheme.tertiaryColor}>
                                <Box className='flexbox'>
                                    {value.icon}
                                    {value.title}
                                </Box>
                            </ColorButton>

                        ))}
                    </Box>
                </>
                :
                <>
                    {MenuList()[selectedTab].obj}
                </>
            }

        </>
    )
}

export default ContabilIndex;